module.exports = require('./helpers/bundle-url').getBundleURL('geQvc') + "sample-check.7ec93ee3.png";